import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "gallery-container" }
const _hoisted_2 = { class: "marquee-container" }
const _hoisted_3 = { class: "column column-left" }
const _hoisted_4 = { class: "scroll-content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "image-container" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "image-overlay" }
const _hoisted_9 = { class: "image-title" }
const _hoisted_10 = {
  key: 0,
  class: "image-description"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "image-container" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "image-overlay" }
const _hoisted_15 = { class: "image-title" }
const _hoisted_16 = {
  key: 0,
  class: "image-description"
}
const _hoisted_17 = { class: "column column-middle" }
const _hoisted_18 = { class: "scroll-content" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "image-container" }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = { class: "image-overlay" }
const _hoisted_23 = { class: "image-title" }
const _hoisted_24 = {
  key: 0,
  class: "image-description"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "image-container" }
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "image-overlay" }
const _hoisted_29 = { class: "image-title" }
const _hoisted_30 = {
  key: 0,
  class: "image-description"
}
const _hoisted_31 = { class: "column column-right" }
const _hoisted_32 = { class: "scroll-content" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "image-container" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = { class: "image-overlay" }
const _hoisted_37 = { class: "image-title" }
const _hoisted_38 = {
  key: 0,
  class: "image-description"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "image-container" }
const _hoisted_41 = ["src", "alt"]
const _hoisted_42 = { class: "image-overlay" }
const _hoisted_43 = { class: "image-title" }
const _hoisted_44 = {
  key: 0,
  class: "image-description"
}
const _hoisted_45 = { class: "lightbox-content" }
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = { class: "caption" }
const _hoisted_48 = ["href"]
const _hoisted_49 = {
  key: 0,
  class: "description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leftColumn, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'left-' + index,
              class: "gallery-item",
              onClick: ($event: any) => (_ctx.openLink(item.link))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: item.imageName,
                  alt: item.title,
                  onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                }, null, 40, _hoisted_7),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
                  (item.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.description), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_5))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leftColumn, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'left-clone-' + index,
              class: "gallery-item",
              onClick: ($event: any) => (_ctx.openLink(item.link))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("img", {
                  src: item.imageName,
                  alt: item.title,
                  onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                }, null, 40, _hoisted_13),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1),
                  (item.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.description), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_11))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.middleColumn, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'middle-' + index,
              class: "gallery-item",
              onClick: ($event: any) => (_ctx.openLink(item.link))
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("img", {
                  src: item.imageName,
                  alt: item.title,
                  onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                }, null, 40, _hoisted_21),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(item.title), 1),
                  (item.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item.description), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_19))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.middleColumn, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'middle-clone-' + index,
              class: "gallery-item",
              onClick: ($event: any) => (_ctx.openLink(item.link))
            }, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("img", {
                  src: item.imageName,
                  alt: item.title,
                  onError: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                }, null, 40, _hoisted_27),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(item.title), 1),
                  (item.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(item.description), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_25))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightColumn, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'right-' + index,
              class: "gallery-item",
              onClick: ($event: any) => (_ctx.openLink(item.link))
            }, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("img", {
                  src: item.imageName,
                  alt: item.title,
                  onError: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                }, null, 40, _hoisted_35),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(item.title), 1),
                  (item.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(item.description), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_33))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightColumn, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'right-clone-' + index,
              class: "gallery-item",
              onClick: ($event: any) => (_ctx.openLink(item.link))
            }, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("img", {
                  src: item.imageName,
                  alt: item.title,
                  onError: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                }, null, 40, _hoisted_41),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, _toDisplayString(item.title), 1),
                  (item.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(item.description), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_39))
          }), 128))
        ])
      ])
    ]),
    (_ctx.lightboxVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "lightbox",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args)))
        }, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "close-btn" }, "×", -1)),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("img", {
              src: _ctx.currentItem.imageName,
              alt: _ctx.currentItem.title,
              onError: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
            }, null, 40, _hoisted_46),
            _createElementVNode("div", _hoisted_47, [
              _createTextVNode(_toDisplayString(_ctx.currentItem.title) + " ", 1),
              _createElementVNode("a", {
                href: _ctx.currentItem.link,
                target: "_blank",
                class: "lightbox-link"
              }, "访问链接", 8, _hoisted_48),
              (_ctx.currentItem.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.currentItem.description), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}